export const learnSubGuides = [
  {
    slug: "texas-community-college",
    number: "01-1",
    icon: "ri-map-pin-2-line",
    parentSlug: "community-college",
    parentTitle: "コミカレの始め方",
    title: "テキサス州のコミカレ選び",
    description:
      "学校の仕組み、比較ポイント、学費・生活費の確認方法、寮と通学環境、留学生の出願条件、編入を見据えた選び方をまとめています。",
  },
  {
    slug: "english-test",
    number: "01-2",
    icon: "ri-translate-2",
    parentSlug: "community-college",
    parentTitle: "コミカレの始め方",
    title: "英語力証明試験",
    description:
      "TOEFL iBT・Duolingo English Test・IELTS Academicの目的と仕組み、出願での使われ方、TSIA2との違いを整理しています。",
  },
];